import { Controller } from 'stimulus'
import consumer       from 'channels/consumer'

export default class extends Controller {
  static targets = ['spinner', 'progress', 'label', 'bar', 'count']

  initialize() {
    this.channel    = "HeavyJobStatusChannel"
    this.heavyJobId = this.data.get("heavy-job-id")
    this.params     = { channel: this.channel, heavy_job_id: this.heavyJobId }

    this.hasParams = this.data.has("params")
  }

  connect() {
    this.subscription = consumer.subscriptions.create(this.params, {
      connected: this._connected.bind(this),
      received:  this._received.bind(this)
    })
  }

  disconnect() {
    if (this.subscription) this.subscription.unsubscribe()
  }

  _connected() {
    const params = { heavy_job_id: this.heavyJobId }

    if (this.hasParams) {
      try {
        const extraParams = JSON.parse(this.data.get("params"))
        Object.keys(extraParams).forEach((k) => (params[k] = extraParams[k]))
      } catch (e) {
        console.warn("Invalid JSON in data-params:", e)
      }
    }
  }

  _received(data) {
    // Long services (preventive workorders generation…) broadcast their
    // progress: swap the anonymous spinner for a real bar.
    if (data && data.status === "progress") {
      this._renderProgress(data)
      return
    }

    if (data && data.status === "ok" && data.redirect_url) {
      const url = new URL(data.redirect_url, window.location.origin)
      if (data.params_key) url.searchParams.set("params_key", data.params_key)

      window.location.assign(url.toString())
      return
    }

    if (data.status === "error") {
      const url = new URL(window.location.origin)
      const error_message = data.error_message
      if (data.error_detail) console.warn("[heavy job]", data.error_detail)

      if (this.data.has("stay-on-error")) {
        closeModal('#remote-modal')
        flashAlert([I18n.t(error_message), data.error_detail].filter(Boolean).join(' '))
      } else {
        if (error_message) { flashAlert(I18n.t(error_message)) }
        window.location.assign(url.toString())
      }
    }

    this.disconnect()
  }

  _renderProgress(data) {
    if (!this.hasProgressTarget) return

    this.spinnerTarget.classList.add('d-none')
    this.progressTarget.classList.remove('d-none')

    if (data.label) this.labelTarget.textContent = data.label
    const percent = data.total > 0 ? Math.round((data.done / data.total) * 100) : 0
    this.barTarget.style.width = `${percent}%`
    this.countTarget.textContent = `${data.done} / ${data.total}`
  }
}
